import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { useDispatch } from 'react-redux';
import { patchNotification } from '../../global/ducks/notification-prc-api';
import { getFormattedDate } from '../../global/helpers/date-helpers';
import { Notification, NotificationPriority, NotificationStatus } from './notification-models';
import { setNotificationRead } from './notification-slice';
import { WysiwygWithReactLink } from '../../global/components/wysiwyg-with-react-link';

interface Props {
	notification: Notification;
	dismissHandler?: (notification: Notification) => void;
	removable: boolean;
	dispatch?: any;
}
export function NotificationItem(props: Props) {	
	
	const { notification, dismissHandler, removable, dispatch: propDispatch } = props;	
	const defaultDispatch = useDispatch();
	const dispatch = propDispatch || defaultDispatch;	
	const dismissMessage = () => {
		const payload = {
			notification_status: NotificationStatus.DISMISSED,
			notification_type: notification?.notification_type,
			recipient_guid: notification?.recipient_guid,
		};
		dispatch(patchNotification(notification?.notification_id, payload, () => dispatch(setNotificationRead(notification?.notification_id))));
		dispatch(setNotificationRead(notification?.notification_id));
	};	

	function AlertDescription(){
		return (
			<>
				<WysiwygWithReactLink content={notification?.notification_body} dispatch={dispatch} />								
			</>
		);
	}
	return (
		<div className='notification-item'>
			<Banner
				banner={{
					type: notification?.priority === NotificationPriority.HIGH ? 'warning' : 'info',
					label: <div className='notification-item-header'><h5>{notification?.notification_subject}</h5><p>{getFormattedDate(notification?.create_timestamp?.toString(), false, true)}</p></div>,
					description: <AlertDescription />,
					onClick: dismissHandler ? () => dismissHandler(notification) : dismissMessage,
					removable,
				}}
			/>
		</div>

	);

}

NotificationItem.defaultProps = {
	dismissHandler: null,
	dispatch: null,
};